export default "__VITE_ASSET__0fe34996__"